import { render, staticRenderFns } from "./detailSoical.vue?vue&type=template&id=0fddfae4&scoped=true&"
import script from "./detailSoical.vue?vue&type=script&lang=js&"
export * from "./detailSoical.vue?vue&type=script&lang=js&"
import style0 from "./detailSoical.vue?vue&type=style&index=0&id=0fddfae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fddfae4",
  null
  
)

export default component.exports